// extracted by mini-css-extract-plugin
export default {"inputContainer":"ConversationInput_inputContainer__4W9lm","input":"ConversationInput_input__rkx5s","sendButton":"ConversationInput_sendButton__Z4c-i"};